import { JOProgress } from '@strata-monorepo/tracking/src/events/JOProgress'
import { TrackingService } from '@strata-monorepo/tracking/src/services/TrackingService'
import saveFmpFunnelCookie from '@strata-monorepo/utils/saveFmpFunnelCookie'
import { getEasternDateTime } from '@strata-monorepo/utils/getEasternDateTime'

const trackFunnelAction = (action: string, site: string): void => {
  if (!site || !action) {
    console.warn('trackFunnelAction: site and action are required')
    return
  }

  const timestamp = getEasternDateTime()
  trackJOProgress(action, timestamp, site)
  saveFmpFunnelCookie(action, timestamp)
}

const trackJOProgress = (cookieName: string, timestamp: string, site: string): void => {
  const JOProgressEventPayload = new JOProgress({
    JOProgressID: cookieName,
    ActivityDateTime: timestamp,
    SiteID: site,
  })

  TrackingService.track(JOProgressEventPayload)
}

export { trackFunnelAction }
